import { Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { useParentChildren } from '@/hooks/use-parent-data';
import {
  Home,
  Users,
  CalendarDays,
  CreditCard,
  MessageSquare,
  Megaphone,
} from 'lucide-react';
import { AppSidebar, NavItem } from '@/components/layout/app-sidebar';

export default function ParentLayout() {
  const { user, logout, isLoading } = useAuth();
  const { data: children } = useParentChildren();

  // Adult students have only self-linked profiles — use "My Profile" instead of "My Players"
  const isAdultStudent =
    children != null && children.length > 0 &&
    children.every(c => c.relationshipType === 'self');

  const navItems: NavItem[] = [
    { id: 'dashboard', href: '/parent', icon: Home, label: 'Dashboard' },
    { id: 'children', href: '/parent/children', icon: Users, label: isAdultStudent ? 'My Profile' : 'My Players' },
    { id: 'calendar', href: '/parent/calendar', icon: CalendarDays, label: 'Calendar' },
    { id: 'messages', href: '/parent/messages', icon: MessageSquare, label: 'Messages' },
    { id: 'announcements', href: '/parent/announcements', icon: Megaphone, label: 'Announcements' },
    { id: 'invoices', href: '/parent/invoices', icon: CreditCard, label: 'Invoices' },
  ];

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <AppSidebar
      navItems={navItems}
      bottomNavIds={['dashboard', 'children', 'calendar', 'invoices']}
      role="parent"
      portalName="Parent Portal"
      user={user}
      onLogout={logout}
    >
      <Outlet />
    </AppSidebar>
  );
}
